import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { getBody, getWindow } from "../../utils/common";
import legoAreaExposure from "../../lego-area-exposure";
import legoGoodsExposure from "../../lego-goods-exposure";
var isNumber = function isNumber(data) {
  return typeof data === 'number';
};
var isFunction = function isFunction(data) {
  return typeof data === 'function';
};

// 定义商品曝光埋点名称和商品所在区域的名称
var GOODS_EXPOSURE_NAME = 'lego-goods-exposure';
var SECTION_ID_NAME = 'zz-sectionid';
var ZZ_BACKUP = 'zz-backup';
var ZZ_CUSTOM_PAGE_TYPE = 'zz-customGoodsExposurePagetype';
var ZZ_NO_SEND_AREA_EXPOSURE = 'zz-noSendAreaExposure';

// 观察根节点的子孙节点新增和删除
export var startMutationObserver = function startMutationObserver(autoGoodsExpose, autoAreaExpose) {
  var root = getBody();
  if (!root) return;
  var mutationObserver = new MutationObserver(function (recordList) {
    var recordListLen = recordList === null || recordList === void 0 ? void 0 : recordList.length;
    if (!recordListLen) return;
    if (autoAreaExpose) {
      taskProcessingAreaExposure();
    }
    if (autoGoodsExpose) {
      taskProcessingGoodsExpose();
    }
  });
  mutationObserver.observe(root, {
    childList: true,
    // 观察目标节点的子节点的新增和删除
    // attributes: true, // 观察目标节点的属性节点（新增或删除了某个属性，以及某个属性的属性值发生了变化）
    subtree: true // 观察目标节点的所有后代节点（观察目标节点所包含的整棵 DOM 树上的上述三种节点变化）
  });
};
// 延迟或线程空闲时执行
export var postponeCallback = function postponeCallback(callback, options) {
  var _ref = options || {},
    isIdle = _ref.isIdle,
    timeout = _ref.timeout;
  var requestIdleCallbackFunc = getWindow('requestIdleCallback');
  if (isFunction(requestIdleCallbackFunc) && isIdle) {
    requestIdleCallbackFunc === null || requestIdleCallbackFunc === void 0 || requestIdleCallbackFunc(function () {
      callback === null || callback === void 0 || callback();
    }, {
      timeout: isNumber(timeout) ? timeout : 200
    });
    return;
  }
  var timer = setTimeout(function () {
    clearTimeout(timer);
    callback === null || callback === void 0 || callback();
  }, isNumber(timeout) ? timeout : 0);
};

// 开始观察面积曝光
var taskProcessingAreaExposure = function taskProcessingAreaExposure() {
  postponeCallback(function () {
    legoAreaExposure();
  }, {
    isIdle: false
  });
};
export var checkFilterComponent = function checkFilterComponent(ele) {
  return ele && ele.getAttribute(ZZ_CUSTOM_PAGE_TYPE) === 'Areaexposure' && ele.getAttribute(ZZ_NO_SEND_AREA_EXPOSURE) === '1';
};

// 开始观察曝光商品
var taskProcessingGoodsExpose = function taskProcessingGoodsExpose() {
  postponeCallback(function () {
    var targetContainers = _toConsumableArray(document.querySelectorAll("[".concat(SECTION_ID_NAME, "]")));
    // 在targetContainers里面查询查找出存在 GOODS_EXPOSURE_NAME 的元素
    var targetContainerArr = [];
    targetContainers.forEach(function (ele) {
      if (Array.from(ele.querySelectorAll("[".concat(GOODS_EXPOSURE_NAME, "]"))).length) {
        // isFilterComponent 筛选组件 sectionId 特殊处理 case
        var isFilterComponent = checkFilterComponent(ele);
        targetContainerArr.push({
          sectionId: ele.getAttribute(SECTION_ID_NAME),
          extraParam: ele.getAttribute(ZZ_BACKUP) ? JSON.parse(ele.getAttribute(ZZ_BACKUP)) : {},
          pagetype: ele.getAttribute(ZZ_CUSTOM_PAGE_TYPE) || '',
          isFilterComponent: isFilterComponent
        });
      }
    });
    if (targetContainerArr.length) {
      legoGoodsExposure(targetContainerArr);
    }
  }, {
    isIdle: false
  });
};